import { Grid } from '@mui/material';
import React, { useState } from 'react';
import WO2Button from 'src/common/components/button/Button';
import { Props } from '../../container';
import { ClientSearchResult } from '../../store/types';
import { ReportingGenerationClientCsvModal } from './ReportingGenerationClientCsvModal';
import { ReportingGenerationClientTable } from './ReportingGenerationClientTable';
import { ReportingGenerationForm } from './ReportingGenerationForm';
import { ReportingGenerationReports } from './ReportingGenerationReports';

export const ReportingGenerationTab = (props: Props): JSX.Element => {
  const [uploadCsvOpened, setUploadCsvOpened] = useState<boolean>(false);
  const [flagReset, setFlagReset] = useState<boolean>(false);

  if (props.reporting.bulk.currentDraft) {
    return <ReportingGenerationReports {...props} />;
  }

  const closeCsvUpload = () => setUploadCsvOpened(false);

  const handleAppendClientsFromCsv = (clients: ClientSearchResult[], allowTerminatedClients: boolean) => {
    props.appendClients(clients);
    props.setAllowTerminatedClient(allowTerminatedClients);
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item container spacing={2} alignItems="center">
        <Grid item flex={1}></Grid>
        <Grid item>
          <WO2Button onClick={() => props.resetBulkReporting()} variant="contained">
            Reset
          </WO2Button>
        </Grid>
        <Grid item>
          <WO2Button onClick={() => setUploadCsvOpened(true)} variant="contained">
            Import Client Ids
          </WO2Button>
        </Grid>
      </Grid>
      <Grid item container spacing={3}>
        <ReportingGenerationForm {...props} setFlagReset={setFlagReset} />
        <ReportingGenerationClientTable {...props} setFlagReset={setFlagReset} flagReset={flagReset} />
      </Grid>

      <ReportingGenerationClientCsvModal
        {...props}
        handleAppendClientsFromCsv={handleAppendClientsFromCsv}
        isOpen={uploadCsvOpened}
        handleClose={closeCsvUpload}
      />
    </Grid>
  );
};
